/**
 * OCHAT: the permission that marks the operator's own account.
 *
 * Kept here rather than in dashboard/constants/permissions.js so that upstream
 * file stays byte-identical. It follows upstream's convention: permissions are
 * role-ish strings ('administrator', 'agent', 'custom_role'), published per
 * account membership by AccountUser#permissions and read by
 * dashboard/helper/permissionsHelper.js.
 *
 * Produced by custom/app/models/custom/account_user.rb for users with
 * users.type = 'SuperAdmin'. Consumed by:
 *   - ochat/routes/routePermissionPolicy.js  -> blocks the reserved routes
 *   - ochat/sidebar/menuPolicy.js            -> hides the reserved menu entries
 */
export const SUPER_ADMIN_PERMISSION = 'super_admin';

export default SUPER_ADMIN_PERMISSION;
